<div class="q-stats">
  <div class="q-header">Start of {{quarter}}</div>
  <app-stats *ngIf="prevData" [values]="prevData"></app-stats>
</div>
<div class="dash-line"></div>
<div class="q-stats">
  <div class="q-header">End of {{quarter}}</div>
  <app-stats *ngIf="nextData" [values]="nextData"></app-stats>
</div>